// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Fj1j","fullView":"styles_fullView__218Ue"};